import classNames from "classnames";

import "./chit.scss";
import {ReactNode} from "react";

type ChitProps = { text: ReactNode, size?: "tiny" | "normal", className?: string };

export function Chit({text, size = "tiny", className = ""}: ChitProps) {
    return <div className={classNames("chit", size, className)}>
        {text}
    </div>;
}
